import type { DeleteUserContentPayload } from '@creator/sdk/modules/upvote';
import creatorSdk from '@src/services/creator-sdk';
import { type Thunk, thunk } from 'easy-peasy';
import type { StoreModel } from '..';

export interface UpvoteModel {
    // tipComment: Thunk<UpvoteModel, TipCommentPayload, null, StoreModel, Promise<Comment>>;
    deleteUserContent: Thunk<UpvoteModel, DeleteUserContentPayload, null, StoreModel, Promise<string>>;
}
const upvoteModel: UpvoteModel = {
    // tipComment: thunk(async (actions, payload) => {
    //     const { commentId } = payload;
    //     const comment = await creatorSdk.upvoteModule.tipComment(payload);

    //     actions.setPostComment({ ...comment, id: commentId, commentId });

    //     return comment;
    // }),

    deleteUserContent: thunk(async (actions, payload) => {
        await creatorSdk.upvoteModule.deleteUserContent(payload);
        // Temp fix
        location.reload();
        return '';
    }),
};

export default upvoteModel;
